// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-info:hover svg[data-v-4acd18bb] {\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
